import apiClient from './apiClient';

// utility to build query string from filters
const buildQuery = (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined && filters[key] !== '') {
      queryParams.append(key, filters[key]);
    }
  });
  return queryParams.toString();
};

export const getLocations = async (filters = {}) => {
  try {
    const q = buildQuery(filters);
    const response = await apiClient.get(`/locations${q ? `?${q}` : ''}`, { skipGlobalError: true });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || 'Locations retrieved successfully',
    };
  } catch (error) {

    if (
      error.response?.status === 404 ||
      error.response?.status === 500 ||
      error.message?.includes('404') ||
      error.message?.includes('500')
    ) {
      console.warn('Locations endpoint not available, using mock data');
      const mock = [
        { id: 'L1', name: 'Head Office', address: '123 Main St, City', timezone: 'UTC' },
        { id: 'L2', name: 'Branch Office', address: '456 Side Ave, City', timezone: 'UTC' },
      ];
      return { success: true, data: mock, message: 'Locations (mock)' };
    }

    const message = error.response?.data?.message || 'Failed to retrieve locations';
    return {
      success: false,
      message,
      error: error.response?.data?.error || error.message,
    };
  }
};

export const createLocation = async (locationData) => {
  try {
    const response = await apiClient.post('/locations', locationData, { skipGlobalError: true });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || 'Location created successfully',
    };
  } catch (error) {
    if (error.response?.status === 404) {
      console.warn('Create location endpoint not found, simulating success');
      const newLoc = { id: `L${Date.now()}`, ...locationData };
      return { success: true, data: newLoc, message: 'Location created (mock)' };
    }
    const message = error.response?.data?.message || 'Failed to create location';
    return { success: false, message, error: error.response?.data?.error || error.message };
  }
};

// optionally export updateLocation, deleteLocation if needed
export const updateLocation = async (id, locationData) => {
  try {
    const response = await apiClient.put(`/locations/${id}`, locationData, { skipGlobalError: true });
    return { success: true, data: response.data.data, message: response.data.message || 'Location updated successfully' };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update location';
    return { success: false, message, error: error.response?.data?.error || error.message };
  }
};

export const deleteLocation = async (id) => {
  try {
    const response = await apiClient.delete(`/locations/${id}`, { skipGlobalError: true });
    return { success: true, data: response.data.data, message: response.data.message || 'Location deleted successfully' };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete location';
    return { success: false, message, error: error.response?.data?.error || error.message };
  }
};

export const bulkUploadLocations = async (formData) => {
    try {
        const response = await apiClient.post('/locations/bulk-upload', formData, { 
            headers: { 'Content-Type': 'multipart/form-data' },
            skipGlobalError: true 
        });
        return { success: true, data: response.data, message: response.data.message || 'Locations uploaded successfully' };
    } catch (error) {
        console.error('Error uploading locations:', error);
        return { success: false, message: error.response?.data?.message || 'Failed to upload locations', error: error.message };
    }
};
